export default "__VITE_PUBLIC_ASSET__5c10a6ee__"